export default "__VITE_ASSET__Becyrr0x__"